import { render, staticRenderFns } from "./ProductSummaryCostModal.vue?vue&type=template&id=656725bc&"
import script from "./ProductSummaryCostModal.vue?vue&type=script&lang=js&"
export * from "./ProductSummaryCostModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports